import { createContext, useContext } from "react";
import { api, type AuthResponse, type User } from "./api";

export type ExternalSession = {
  access_token: string;
  refresh_token: string;
  expires_in?: number;
  token_type?: string;
  auth_method?: string;
};

export type AuthValue = {
  user: User | null;
  loading: boolean;
  signIn: (email: string, password: string) => Promise<User>;
  signUp: (body: Parameters<typeof api.register>[0]) => Promise<User>;
  signOut: () => Promise<void>;
  refresh: () => Promise<void>;
  applySession: (session: ExternalSession) => Promise<User>;
  applyAuthResponse: (resp: AuthResponse) => User;
  pendingEmail: string | null;
  setPendingEmail: (email: string | null) => void;
};

export const AuthContext = createContext<AuthValue | null>(null);

export function useAuth(): AuthValue {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used within AuthProvider");
  return ctx;
}
